/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";

import GroupTable from "../components/GroupTable";
import GroupForm from "../components/GroupForm";
import GroupDetailModal from "../components/calendar/GroupDetailModal";
import PageDocumentation from "../components/PageDocumentation";
import useGroups from "../hooks/useGroups";

function Groups() {
  const [mode, setMode] = useState("list");
  const [groupModalVisible, setGroupModalVisible] = useState(false);

  const { getGroup, getGroups, group, setGroup } = useGroups();

  const handleGroupClick = async (record) => {
    await getGroup(record.id);
    setGroupModalVisible(true);
  };

  const handleCloseGroupModal = () => {
    setGroupModalVisible(false);
    setGroup(null);
  };

  const handleGroupUpdate = () => {
    // Refrescar los datos del grupo después de una actualización
    if (group?.id) {
      getGroup(group.id);
    }
    // También refrescar la lista de grupos
    getGroups();
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-xl font-semibold">Grupos</h1>
        <PageDocumentation docKey="groups" />
      </div>
      {mode === "list" ? (
        <GroupTable
          onModeSet={(mode) => {
            setMode(mode);
          }}
          onGroupClick={handleGroupClick}
        />
      ) : (
        <GroupForm
          groupToEdit={null}
          onSetList={() => {
            setMode("list");
          }}
        />
      )}

      {/* Group Detail Modal */}
      <GroupDetailModal
        visible={groupModalVisible}
        group={group}
        onClose={handleCloseGroupModal}
        onUpdate={handleGroupUpdate}
      />
    </div>
  );
}

export default Groups;
